import moment from "moment/moment";

export const documentStatusGlobal = {
    created: 0,
    sent: 1,
    signed: 2,
    refused: 3,
    canceled: 4,
};

export const documentStatusUrlMap = {
    0: "/not-signed/",
    1: "/sent/",
    2: "/signed/",
    3: "/rejected/",
    4: "/canceled/",
}
export const countryOptions = [
    { value: 'ES', label: 'El Salvador' },
    { value: 'HO', label: 'Honduras' },
    { value: 'CO', label: 'Colombia' }
];

export const documentTypes = [
    { value: 1 , label: 'DUI' },
    { value: 2 , label: 'Pasaporte' },
    { value: 3 , label: 'Carnet de Residencia' }
]

export const statusOptions = [
    { value: true, label: 'Activa' },
    { value: false, label: 'Inactiva' }
]

export const signersList = () => {
    // Generar un arreglo vacío para almacenar los objetos aleatorios
    const randomObjects = [];

    // Definir las posibles opciones para los valores de las propiedades
    const possibleSignerNames = ["Eliana Suancha Guzman", "Juan Perez", "Maria Garcia", "Carlos Ortiz", "Andres Perez", "Claudia Osorio", "Beatriz Gonzales"];
    const possibleSignerTypes = ["Interno", "Externo"];
    const possibleSocieties = ["CrediQ", "Banco Popular", "Banco de Bogotá", "Bancolombia"];
    const possibleCountries = ["Colombia", "El Salvador", "Honduras"];
    const possibleDocumentTypes = ["ID", "Carnet de Residente", "Pasaporte"];
    const possibleDocumentNumbers = ["23935252", "36290143", "45029381", "58762301"];
    const possiblePhoneNumbers = ["503 7026656", "503 5567890", "503 1234567", "503 9876543"];
    const possibleEmails = ["elian@mail.com", "juan@gmail.com", "maria@hotmail.com", "carlos@yahoo.com"];
    const possibleStatus = ["Activa", "Inactiva"];

    // Generar objetos aleatorios y agregarlos al arreglo
    for (let i = 0; i < 80; i++) {
        const randomObject = {
            noSigner: i + 1,
            signerName: possibleSignerNames[Math.floor(Math.random() * possibleSignerNames.length)],
            createDate: moment().format("DD/MM/YYYY"),
            signerType: possibleSignerTypes[Math.floor(Math.random() * possibleSignerTypes.length)],
            society: possibleSocieties[Math.floor(Math.random() * possibleSocieties.length)],
            country: possibleCountries[Math.floor(Math.random() * possibleCountries.length)],
            documentType: possibleDocumentTypes[Math.floor(Math.random() * possibleDocumentTypes.length)],
            documentNumber: possibleDocumentNumbers[Math.floor(Math.random() * possibleDocumentNumbers.length)],
            phoneNumber: possiblePhoneNumbers[Math.floor(Math.random() * possiblePhoneNumbers.length)],
            email: possibleEmails[Math.floor(Math.random() * possibleEmails.length)],
            status: possibleStatus[Math.floor(Math.random() * possibleStatus.length)],
        };
        randomObjects.push(randomObject);
    }

    return randomObjects;
}

export const areaList = () => {
    const randomObjects = [];
    const possibleStatus = ["Activa", "Inactiva"];

    for (let i = 0; i < 50; i++) {
        const randomObject = {
            areaId: i + 1,
            areaName: `Area ${Math.floor(Math.random() * 6)}`,
            status: possibleStatus[Math.floor(Math.random() * possibleStatus.length)],
        };
        randomObjects.push(randomObject);
    }

    return randomObjects;
}

export const checkIsValid = (data) => {
    return Object.values(data).every((field) =>
        (typeof field === 'object' ? field !== null : field?.toString().length > 0)
    )
}